import axios from "axios";
import { sanitizeUrl } from "@braintree/sanitize-url";
import filterXSS from "xss";
import { getNestedObject } from "../utils/common";

let loadingTimer;

const locationUrl = window.location.origin;
let amLocation = '/openam/json/realms/root/realms/BOSCitizens/';
let oauth2 = '/openam/oauth2/realms/root/realms/BOSCitizens/';
let logOutUrl = '/openam/IDPSloInit?metaAlias=/BOSCitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=';
const loginUrl = '/ctidentity/login';

window.ajaxCallsCount = window.ajaxCallsCount || 0;

const showLoader = () => {
  const loader = document.querySelector(".loader");
  clearTimeout(loadingTimer);
  if (loader) {
    loader.classList.remove("hide");
  }
  window.ajaxCallsCount++;
};

const addHideClassToLoader = () => {
  const loader = document.querySelector(".loader");
  if (loader) {
    loader.classList.add("hide");
  }
};

/**
 * @description filter config
 * @param {object} object object to be filtered
 * @returns {object} XSS filtered object
 */
const filterXSSObject = (object) => {
  Object.keys(object).forEach((key) => {
    const value = object[key];
    const objectType = Object.prototype.toString.call(value);
    if (objectType === "[object Object]" || objectType === "[object Array]") {
      filterXSSObject(value);
    } else if (typeof value === "string") {
      object[key] = filterXSS(value);
    }
  });
};

const hideLoading = () => {
  window.ajaxCallsCount--; // decrement this global variable when ajax req is complete
  if (window.ajaxCallsCount === 0) {
    // hide loader only if all active ajax requests are done
    loadingTimer = setTimeout(addHideClassToLoader, 200);
  }
};

const httpRequest = (
  config,
  extraHeaders,
  reauthHeader,
  showGlobalLoader = true,
  preventHidingLoader = false
) => {
  if (showGlobalLoader) {
    showLoader();
  }
  if (reauthHeader) {
    filterXSSObject(reauthHeader)
  }
  const defaultConfig = {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
      ...extraHeaders,
      ...reauthHeader
    }
  };

  let url;
  let apiEndPoint; 
  if (locationUrl.indexOf('dev.login.ct.gov') > 0) {
    apiEndPoint = 'https://dev.account.ct.gov/openidm/';
  } else if (locationUrl.indexOf('stg.login.ct.gov') > 0) {
    apiEndPoint = 'https://stg.account.ct.gov/openidm/';
    amLocation = '/json/realms/root/realms/boscitizens/';
    oauth2 = '/oauth2/realms/root/realms/boscitizens/';
    logOutUrl = '/IDPSloInit?metaAlias=/boscitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=';
  } else if (locationUrl.indexOf('devc.login.ct.gov') > 0) {
    apiEndPoint = 'https://devc.account.ct.gov/openidm/';
    amLocation = '/json/realms/root/realms/boscitizens/';
    oauth2 = '/oauth2/realms/root/realms/boscitizens/';
    logOutUrl = '/IDPSloInit?metaAlias=/boscitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=';
  } else if (locationUrl.indexOf('psup.login.ct.gov') > 0) {
    apiEndPoint = 'https://psup.account.ct.gov/openidm/';
    amLocation = '/json/realms/root/realms/boscitizens/';
    oauth2 = '/oauth2/realms/root/realms/boscitizens/';
    logOutUrl = '/IDPSloInit?metaAlias=/boscitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState='; 
  } else if (locationUrl.indexOf('login.ct.gov') > 0) {
    apiEndPoint = 'https://account.ct.gov/openidm/';
    amLocation = '/json/realms/root/realms/boscitizens/';
    oauth2 = '/oauth2/realms/root/realms/boscitizens/';
    logOutUrl = '/IDPSloInit?metaAlias=/boscitizens/devidp&binding=urn:oasis:names:tc:SAML:2.0:bindings:HTTP-POST&RelayState=';
  }
  if (
    config.url.includes("authenticate") ||
    config.url.includes("lastLoginTimestamp") ||
    config.url.includes("/devices/profile") ||
    config.url.includes("sessions/?_action=getSessionInfo")
  ) {
    url = `${locationUrl}${amLocation}${config.url}`;
  } else if (config.url.includes('authorize') ||
    config.url.includes('access_token')) {
    url = `${locationUrl}${oauth2}${config.url}`;
  } else if (config.useDirectUrl) {
    url = `${config.url}`;
  } else {
    url = `${apiEndPoint}${config.url}`;
  }
  url = sanitizeUrl(url);
  filterXSSObject(config);
  const mergedConfig = {
    ...defaultConfig,
    ...config,
    url
  };

  return axios(mergedConfig)
    .then((res) => {
      filterXSSObject(res);
      if (showGlobalLoader) {
        if (!preventHidingLoader) {
          hideLoading();
        } else {
          window.ajaxCallsCount--;
        }
      }
      return res;
    })
    .catch((error) => {
      if (showGlobalLoader) {
        hideLoading();
      }
      if (
        getNestedObject(error, ["response", "data", "code"]) === 401 &&
        getNestedObject(error, ["response", "data", "reason"]) ===
          "Unauthorized" &&
        getNestedObject(error, ["response", "data", "message"]) ===
          "Access Denied"
      ) {
        window.location.href = sanitizeUrl(`${locationUrl}${logOutUrl}${locationUrl}${loginUrl}`);
      }
      if (error.response) {
        return error.response;
      }
      return error;
    });
};

export default httpRequest;
